import {selectSessionUser} from "../../../../../store/authentication/selectors";
import React from "react";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import constants from "../../../../../config/constants";
import * as io from "socket.io-client";
import StateIntroTTA from "./mainScreens/StateIntroTTA";
import StateDefaultTTA from "./mainScreens/StateDefaultTTA";

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        user: selectSessionUser(state),
    };
};

const mapActionsToDispatch = dispatch => ({});

const mergeProps = (stateProps, dispatchProps) => ({
    ...stateProps,
    ...dispatchProps
});


class ThoughTheAgesHome extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            state: undefined,
            play: true,
            consult: "centrale",
            checkNewState: false
        };
    }

    socketThroughTheAges;

    componentDidMount() {
        const {gameId} = this.props.match.params;
        this.socketThroughTheAges = io.connect(constants.api.socketPath);
        setTimeout(() => {
            this.socketThroughTheAges.emit("id", {
                type: "PLAYER",
                gameId,
                userId: "" + this.props.user._id,
                username: this.props.user.username,
                color: {r: 0.750, g: 0.75, b: 0.75, a: 1}
            })
        }, 1000);
        let a = this;
        this.socketThroughTheAges.on('disconnect', function () {
            a.props.history.push("/board-games");
        });
        this.socketThroughTheAges.on('state', function (data) {
            console.log('new state');
            console.log(data);
            if (data && (data.state !== "INTRO" || !a.state.data)) {
                const newState = {state: data};
                if (a.state.play && (!data.actions || !data.actions[a.props.user._id] || !data.actions[a.props.user._id].length)) {
                    newState.play = false;
                    newState.checkNewState = false;
                } else if (!a.state.play && data.actions && data.actions[a.props.user._id] && data.actions[a.props.user._id].length && !a.state.checkNewState) {
                    newState.play = true;
                    newState.checkNewState = true;
                }
                a.setState(newState);
            }
        });
        this.socketThroughTheAges.on('state_intro', function (data) {
            console.log('new state intro');
            console.log(data);
            if (!a.state.state || a.state.state.state === "INTRO") {
                a.setState({state: data});
            }
        });
    }

    componentWillUnmount() {
        this.socketThroughTheAges.close();
    }

    render() {
        let comp = undefined;
        let compConsult = undefined;
        if (!this.state.state) {
            return <div style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: "20px",
                color: "#CCC"
            }}>
                Veuillez patienter
            </div>
        }
        const {gameId} = this.props.match.params;
        if (this.state.state) {
            switch (this.state.state.state) {
                case "INTRO":
                    return <div style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        <StateIntroTTA
                            state={this.state.state}
                            userId={this.props.user._id}
                            gameId={gameId}
                            username={this.props.user.username}
                            socket={this.socketThroughTheAges}
                        />
                    </div>;
                default:
                    comp = <StateDefaultTTA
                                state={this.state.state}
                                userId={this.props.user._id}
                                socket={this.socketThroughTheAges}
                                />
            }
            switch (this.state.consult) {
                default:
                    break;
            }
        }

        return <div style={{width: "100%", height: "100vh", marginTop: "-1px"}}>
            <div
                style={{
                    width: "100%", height: "12%", display: "flex", justifyContent: "center", alignItems: "center",
                    background: "linear-gradient(0, #DDD 0%, #555 100%)"
                }}>
                <div style={{
                    width: "50%",
                    height: "80%",
                    marginTop: "3px",
                    display: "flex",
                    flexDirection: "row"
                }}>
                    <div style={{
                        flex: 10,
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        borderRadius: "5px",
                        color: "#FFF",
                        backgroundColor: this.state.play ? "rgb(91, 192, 222)" : (
                            this.state.state.actions[this.props.user._id] && this.state.state.actions[this.props.user._id].length ?
                                "#4daa70" : "#000"
                        )
                    }} onClick={() => {
                        if (this.state.state.actions[this.props.user._id] && this.state.state.actions[this.props.user._id].length) {
                            this.setState({play: true})
                        }
                    }}>
                        {this.state.state.actions[this.props.user._id] && this.state.state.actions[this.props.user._id].length ? "JOUER" : "EN ATTENTE"}
                    </div>
                    <div style={{flex: 1, height: "100%", justifyContent: "center", alignItems: "center"}}>

                    </div>
                    <div style={{
                        flex: 10,
                        height: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        borderRadius: "5px",
                        color: "#FFF",
                        backgroundColor: !this.state.play ? "rgb(91, 192, 222)" : "#777"
                    }}
                         onClick={() => this.setState({play: false})}>
                        CONSULTER
                    </div>
                </div>
            </div>
            {
                this.state.play ?
                    <div
                        style={{width: "100%", height: "88%", backgroundColor: "#111", marginTop: "-1px"}}>
                        {
                            comp || JSON.stringify(this.state.state)
                        }
                    </div>
                    : <div
                        style={{width: "100%", height: "88%", backgroundColor: "#111", marginTop: "-1px"}}>
                        <div
                            style={{
                                width: "100%",
                                height: "12%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                background: "linear-gradient(0, #88D 0%, #559 100%)"
                            }}>
                            <div style={{
                                width: "90%",
                                height: "80%",
                                marginTop: "3px",
                                display: "flex",
                                flexDirection: "row"
                            }}>
                                <div style={{
                                    flex: 10,
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    borderRadius: "5px",
                                    color: "#FFF",
                                    backgroundColor: this.state.consult === "centrale" ? "rgb(91, 192, 222)" : "#777"
                                }} onClick={() => {
                                    this.setState({consult: "consult1"})
                                }}>
                                    SCREEN 1
                                </div>
                                <div style={{flex: 1, height: "100%", justifyContent: "center", alignItems: "center"}}>

                                </div>
                                <div style={{
                                    flex: 10,
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    borderRadius: "5px",
                                    color: "#FFF",
                                    backgroundColor: this.state.consult === "resources" ? "rgb(91, 192, 222)" : "#777"
                                }} onClick={() => {
                                    this.setState({consult: "consult2"})
                                }}>
                                    SCREEN 2
                                </div>
                                <div style={{flex: 1, height: "100%", justifyContent: "center", alignItems: "center"}}>

                                </div>
                                <div style={{
                                    flex: 10,
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    borderRadius: "5px",
                                    color: "#FFF",
                                    backgroundColor: this.state.consult === "cities" ? "rgb(91, 192, 222)" : "#777"
                                }} onClick={() => {
                                    this.setState({consult: "consult3"})
                                }}>
                                    CONSULT 3
                                </div>
                                <div style={{flex: 1, height: "100%", justifyContent: "center", alignItems: "center"}}>

                                </div>
                                <div style={{
                                    flex: 10,
                                    height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    borderRadius: "5px",
                                    color: "#FFF",
                                    backgroundColor: this.state.consult === "income" ? "rgb(91, 192, 222)" : "#777"
                                }} onClick={() => {
                                    this.setState({consult: "consult4"})
                                }}>
                                    CONSULT 4
                                </div>
                            </div>
                        </div>
                        {
                            compConsult
                        }
                    </div>
            }
        </div>
    }
}

export default withRouter(connect(mapStateToProps, mapActionsToDispatch, mergeProps, {pure: false})(ThoughTheAgesHome))
